
<div class="page">

    <div class="page-header">
        <div class="breadcrumb">
            <p-breadcrumb [model]="breadcrumbs" [home]="homeBreadcrumb"></p-breadcrumb>
        </div>
        <div class="search">
            <input pInputText type="text" (input)="filter(dt, $event)" placeholder="Search..." />           
        </div>
        <div class="actions">
            <button pButton pRipple label="New" icon="pi pi-plus" class="button-action p-button-success p-mr-2" (click)="openNew()"></button>
            <button pButton pRipple label="Delete" icon="pi pi-trash" class="button-action p-button-danger" (click)="deleteSelectedDispatches()" [disabled]="!selectedDispatches || !selectedDispatches.length "></button>
        </div> 
    </div>

    <div class="page-content">
        <p-table #dt 
            [value]="dispatches"                                                                                                      
            [rows]="10" 
            [paginator]="true" 
            [globalFilterFields]="['position','qrcode','name','description','tags','status']"
            [rowsPerPageOptions]="[5,10,25,50,100]"
            [(selection)]="selectedDispatches" 
            [resizableColumns]="true"
            [reorderableColumns]="true"
            [rowHover]="true" 
            dataKey="$key"
            styleClass="p-datatable-striped"
            currentPageReportTemplate="{first} to {last} of {totalRecords}" 
            [showCurrentPageReport]="true"
            selectionMode="multiple"
            [columns]="selectedColumns"
            (onRowReorder)="reorder($event)"
            sortField="position" 
            [sortOrder]="1"
            >

            <ng-template pTemplate="colgroup">
                <colgroup>
                    <col style="max-width:10%">
                    <col style="max-width:20%">
                    <col style="min-width:10%;max-width:80%">
                    <col style="max-width:20%">
                </colgroup>
            </ng-template>
            
            <ng-template pTemplate="caption">
                <p-multiSelect [options]="cols" [(ngModel)]="selectedColumns" optionLabel="header"
                selectedItemsLabel="{0} columns selected" [style]="{minWidth: '200px'}" placeholder="Choose Columns"></p-multiSelect>
            </ng-template>

            <ng-template pTemplate="header" let-columns="columns">
                <tr>
                    <th pResizableColumn pSortableColumn="position" style="width: 8rem">
                        Order<p-sortIcon field="position"></p-sortIcon>
                    </th>
                    <th id="qrcode" style="width: 8rem" name="qrcode" pResizableColumn pReorderableColumn pSortableColumn="qrcode" [class]="includesCol('qrcode') ? 'd' : 'h'">QRCode 
                        <p-sortIcon field="name"></p-sortIcon> 
                        <p-columnFilter type="text" field="name" display="menu"></p-columnFilter> 
                    </th>
                    <th id="name" name="name" pResizableColumn pReorderableColumn pSortableColumn="name" [class]="includesCol('name') ? 'd' : 'h'">Name 
                        <p-sortIcon field="name"></p-sortIcon> 
                        <p-columnFilter type="text" field="name" display="menu"></p-columnFilter>
                    </th>
                    <th id="dispatchAt" name="dispatchAt" pResizableColumn pReorderableColumn pSortableColumn="dispatchAt" [class]="includesCol('dispatchAt') ? 'd' : 'h'">At 
                        <p-sortIcon field="dispatchAt"></p-sortIcon> 
                        <p-columnFilter type="text" field="dispatchAt" display="menu"></p-columnFilter>
                    </th>
                    <th id="dispatchBy" name="dispatchBy" pResizableColumn pReorderableColumn pSortableColumn="dispatchBy" [class]="includesCol('dispatchBy') ? 'd' : 'h'">By 
                        <p-sortIcon field="dispatchBy"></p-sortIcon> 
                        <p-columnFilter type="text" field="dispatchBy" display="menu"></p-columnFilter>
                    </th>
                    <th id="items" name="items" pResizableColumn pReorderableColumn pSortableColumn="items" [class]="includesCol('items') ? 'd' : 'h'">Content 
                        <p-sortIcon field="items"></p-sortIcon> 
                        <p-columnFilter type="text" field="items" display="menu"></p-columnFilter>
                    </th>
                    <th id="description" name="description" pResizableColumn pReorderableColumn [class]="includesCol('description') ? 'd' : 'h'">Notes
                        <p-sortIcon field="description"></p-sortIcon> 
                        <p-columnFilter type="text" field="description" display="menu"></p-columnFilter>
                    </th>
                    <th id="tags" name="tags" pResizableColumn pReorderableColumn [class]="includesCol('tags') ? 'd' : 'h'">Tags
                        <p-sortIcon field="tags"></p-sortIcon> 
                        <p-columnFilter type="text" field="tags" display="menu"></p-columnFilter>
                    </th>
                    <th id="isEnabled" name="isEnabled" pResizableColumn pReorderableColumn pSortableColumn="isEnabled" style="width: 10rem" [class]="includesCol('isEnabled') ? 'show' : 'hide'">
                        Enabled
                        <p-sortIcon field="isEnabled"></p-sortIcon> 
                        <p-columnFilter type="boolean" field="isEnabled" display="menu"></p-columnFilter>
                    </th>
                    <th pResizableColumn pReorderableColumn style="width: 8rem">
                        Actions 
                        <!-- <button type="button" pButton pRipple icon="pi pi-file-o" (click)="dt.exportCSV();" class="p-mr-2" pTooltip="CSV" tooltipPosition="bottom"></button> -->
                        <p-tableHeaderCheckbox style="float: right;margin-right:3px" class="checkbox"></p-tableHeaderCheckbox>
                    </th>
                    
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-dispatch let-columns="columns" let-index="rowIndex">
                <tr [pReorderableRow]="index" >
                    <td pEditableColumn>
                        <span *ngIf="isReordering && !isFilter" class="pi pi-bars" [pReorderableRowHandle]="index" style="margin-right: 1rem;"></span>
                        <p-cellEditor>
                            <ng-template pTemplate="input">
                                <input pInputText type="text" 
                                (ngModelChange)="modelChangeFn($event, dispatch)"
                                [ngModel]="dispatch.position" 
                                (blur)="completePosition(dispatch)" 
                                (keydown.tab)="completePosition(dispatch)" 
                                (keydown.enter)="completePosition(dispatch)"  
                                required>
                            </ng-template>
                            <ng-template pTemplate="output">
                                {{index}}
                                <!-- ( {{dispatch.position}} ) -->
                            </ng-template>
                        </p-cellEditor>
                    </td>

                    <td pEditableColumn [class]="includesCol('qrcode') ? 'd' : 'h'">
                        <qrcode [qrdata]="dispatch.name" [width]="100" [errorCorrectionLevel]="'M'"></qrcode>
                    </td>

                    <td pEditableColumn [class]="includesCol('name') ? 'd' : 'h'">
                        <p-cellEditor>
                            <ng-template pTemplate="input">
                                <input pInputText type="text" [(ngModel)]="dispatch.name" 
                                (blur)="completeDispatch(dispatch)" 
                                (keydown.tab)="completeDispatch(dispatch)" 
                                (keydown.enter)="completeDispatch(dispatch)" 
                                 required>
                            </ng-template>
                            <ng-template pTemplate="output" >
                                <span >{{dispatch.name}}</span>
                            </ng-template>
                        </p-cellEditor>
                    </td>

                    <td pEditableColumn [class]="includesCol('dispatchAt') ? 'd' : 'h'" >
                        <p-cellEditor >
                            <ng-template pTemplate="input" >
                                <input pInputText type="text" [(ngModel)]="dispatch.dispatchAt"  (blur)="completeDispatch(dispatch)" (keydown.tab)="completeDispatch(dispatch)" (keydown.enter)="completeDispatch(dispatch)"  required>
                            </ng-template>
                            <ng-template pTemplate="output">
                                <span >{{dispatch.dispatchAt}}</span>
                            </ng-template>
                        </p-cellEditor>
                    </td>

                    <td pEditableColumn [class]="includesCol('dispatchBy') ? 'd' : 'h'" >
                        <p-cellEditor >
                            <ng-template pTemplate="input" >
                                <input pInputText type="text" [(ngModel)]="dispatch.dispacthBy"  (blur)="completeDispatch(dispatch)" (keydown.tab)="completeDispatch(dispatch)" (keydown.enter)="completeDispatch(dispatch)"  required>
                            </ng-template>
                            <ng-template pTemplate="output">
                                <span >{{dispatch.dispacthBy}}</span>
                        
                            </ng-template>
                        </p-cellEditor>
                    </td>

                    <td pEditableColumn [class]="includesCol('items') ? 'd' : 'h'" >
                        <p-cellEditor >
                            <ng-template pTemplate="input" >
                                <input pInputText type="text" [(ngModel)]="dispatch.items"  (blur)="completeDispatch(dispatch)" (keydown.tab)="completeDispatch(dispatch)" (keydown.enter)="completeDispatch(dispatch)"  required>
                            </ng-template>
                            <ng-template pTemplate="output">
                                <span >{{dispatch.items}}</span>
                        
                            </ng-template>
                        </p-cellEditor>
                    </td>

                    <td pEditableColumn [class]="includesCol('description') ? 'd' : 'h'" >
                        <p-cellEditor >
                            <ng-template pTemplate="input" >
                                <input pInputText type="text" [(ngModel)]="dispatch.description"  (blur)="completeDispatch(dispatch)" (keydown.tab)="completeDispatch(dispatch)" (keydown.enter)="completeDispatch(dispatch)"  required>
                            </ng-template>
                            <ng-template pTemplate="output">
                                <span >{{dispatch.description}}</span>
                            
                         
                            </ng-template>
                        </p-cellEditor>
                    </td>

                    

                    <td pEditableColumn [class]="includesCol('tags') ? 'd' : 'h'" >
                        <p-cellEditor >
                            <ng-template pTemplate="input" >
                                <p-chips  id="tags" [(ngModel)]="dispatch.tags" [separator]="separatorExp" placeholder="tag1, tag2 tag3" (onBlur)="completeDispatch(dispatch)" (onAdd)="completeDispatch(dispatch)" (onRemove)="completeDispatch(dispatch)"></p-chips>
                            </ng-template>
                            <ng-template pTemplate="output">
                                <span style="margin-right: 5px;" *ngFor="let tag of dispatch.tags">
                                    <p-tag >{{tag}}</p-tag>
                                </span>
                               
                       
                            </ng-template>
                        </p-cellEditor>
                    </td>

                    <td pEditableColumn [class]="includesCol('isEnabled') ? 'd' : 'h'" class="enabled" style="text-align: center;">
                        <p-inputSwitch  [(ngModel)]="dispatch.isEnabled" (onChange)="completeDispatch(dispatch)"></p-inputSwitch>
                    </td>

                    <td class="row-actions">
                        <button style="margin-right: 10px" pButton pRipple icon="pi pi-pencil" class="p-button-rounded p-button-success p-mr-2" (click)="editDispatch(dispatch)"></button>
                        <button style="margin-right: 10px" pButton pRipple icon="pi pi-trash" class="p-button-rounded p-button-warning" (click)="deleteDispatch(dispatch)"></button>
                        <p-tableCheckbox class="checkbox" [value]="dispatch"></p-tableCheckbox>
                        
                    </td>
                </tr>
            </ng-template>
            <ng-template pTemplate="summary">
                <div class="summary">
                    <div class="summary-total">
                        Total: {{dispatches ? dispatches.length : 0 }} dispatch{{dispatches.length > 1? 's': ''}}
                    </div>
                    <div class="summary-export">
                        <button style="margin-right: 10px"type="button" pButton pRipple icon="pi pi-file-o" (click)="exportToCsv()" class="p-mr-2" pTooltip="CSV - Save the selected lines and columns" tooltipPosition="bottom"></button>
                        <button style="margin-right: 10px"type="button" pButton pRipple icon="pi pi-file-excel" (click)="exportExcel()" class="p-button-success p-mr-2"  pTooltip="XLS - Save all the lines and columns" tooltipPosition="bottom"></button>
                        <button type="button" pButton pRipple icon="pi pi-file-pdf" (click)="exportPdf()" class="p-button-warning p-mr-2" pTooltip="PDF - Save all the lines and columns" tooltipPosition="bottom"></button>
                    </div>
                </div>
            </ng-template>
        </p-table>

    </div>

    <div class="page-footer">
        <div class="p-d-flex">
            <!-- <button type="button" pButton pRipple icon="pi pi-filter" (click)="dt.exportCSV({selectionOnly:true})" class="p-button-info p-ml-auto" pTooltip="Selection Only" tooltipPosition="bottom"></button> -->
        </div>        
    </div>

    <!-- Dialog : confirm -->
    <p-confirmDialog [style]="{width: '450px'}"></p-confirmDialog>
    

    <!-- Dialog : Popup -->
    <p-dialog [(visible)]="dispatchDialog" [style]="{width: '870px', height: '500px'}" header="Dispatch" [modal]="true" styleClass="p-fluid" [baseZIndex]='1000'>
        

        <div class="line">

            <div class="p-field" style="margin-top: 10px; width:45%">
                <label for="output">Reason</label>
                <br />
                <p-dropdown 
                    id="output"
                    appendTo="body" 
                    [filter]="true"
                    [showClear]="true" 
                    [(ngModel)]="outputTypeKey" 
                    [options]="outputTypes" 
                    optionLabel="name" 
                    optionValue="name"
                    placeholder="Any">
                </p-dropdown> 
            </div>

            <div *ngIf="isSales()" class="p-field" style="margin-top: 10px; width:45%">
                <label for="client">For</label>
                <br>
                <p-dropdown 
                    id="client"
                    appendTo="body" 
                    [filter]="true"
                    [showClear]="true" 
                    [(ngModel)]="clientKey" 
                    [options]="clients" 
                    optionLabel="companyName" 
                    optionValue="companyName"
                    placeholder="Any">
            </p-dropdown>  
            </div>

        </div>

        
        <div style="margin-top: 20px">
            <label for="client">Content / Packs</label>
                <br>
            <p-pickList #pl 
                [responsive]="true" 
                [source]="list1" 
                [target]="list2" 
                [dragdrop]="true"
                sourceHeader="Available packs" 
                targetHeader="To dispatch" 
                [responsive]="true" 
                [sourceStyle]="{'width':'320px','height':'200px'}" 
                [targetStyle]="{'width':'320px','height':'200px'}" 
                filterBy="name,batch,location"
                (onMoveToTarget)="moveToTarget($event)"
                (onMoveAllToTarget)="moveToTarget($event)"
                (onMoveToSource)="moveToSource($event)"
                (onMoveAllToSource)="moveToSource($event)"
                (onSourceReorder)="sourceReorder($event)"
                sourceFilterPlaceholder="Search" 
                targetFilterPlaceholder="Search"
                [disabled]="disabledPickList()"
            >
                <ng-template let-recipe pTemplate="item">
                    <div>
                        <!-- <img src="assets/showcase/images/demo/car/{{car.brand}}.png" style="display:inline-block;margin:2px 0 2px 2px" width="48"> -->
                        <div style="font-size:14px;float:right;margin:15px 5px 0 0">{{recipe.name}} - {{recipe.batch}} ( {{recipe.location}} )</div>
                    </div>
                </ng-template>
            </p-pickList>

        </div>
        
        <div class="p-field">
            <label for="description">Notes</label>
            <textarea style="margin-top: 10px;" id="description" pInputTextarea [(ngModel)]="dispatch.description" rows="3" cols="20"></textarea>
        </div>
        <div class="p-field">
            <label for="tags" >Tags</label>
            <div style="height: 10px;">&nbsp;</div>
            <p-chips  id="tags" [(ngModel)]="dispatch.tags" [separator]="separatorExp" placeholder="tag1, tag2 tag3"></p-chips>
        </div>   
        <div class="in-out" style="margin-top: 20px;">
            <button pButton pRipple label="Cancel" icon="pi pi-times" class="button-action p-button-danger p-mr-2" (click)="hideDialog()"></button>
            <button pButton pRipple label="Save" icon="pi pi-check" class="button-action p-button-success" (click)="saveDispatch()"></button>
        </div>
    </p-dialog>
    
    

</div>






